export default {
  getFactoryItem: (state) => state.factoryItem,
};
